export default function (to, from, next) {
    if (to.matched.length === 0) {
        return next({
            name: "notfound"
        });
    }

    next();
}